module.exports = __webpack_public_path__ + "weChat.0cd71eec.png";